import { Link } from "react-router-dom";
import "./index.css";
import WhatYouGet from "../WhatYouGet";
import ContentStrategySection from "../ContentStrategySection";
import TurnYourStorySection from "../TurnYourStorySection";
import CarouselComponent from "../ui/Carousel";
import YourValues from "../YourValues";
import Footer from "../Footer";
import { useEffect, useState } from "react";

export const WhatWeDo = () => {
  const [isFixed, setIsFixed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 460) {
        // Adjust scroll distance as needed
        setIsFixed(true);
      } else {
        setIsFixed(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <>
      <div className="px-8 max-w-xl mx-auto flex flex-col space-y-16 mt-8 align-middle ">
        <section>
          <h3 className="text-center mb-5 font-playfair font-bold">WHAT WE DO</h3>

          <p className="text-start font-lato">
            You want to show what your business stands for but feel stuck,
            unsure how to make it meaningful. We help you unlock your unique
            story and turn it into content that captures your purpose—content
            that’s impossible to copy. Your stories can become albums, memories,
            and social media posts that resonate deeply. It’s not just your
            past; it’s a powerful way to reach people.
          </p>
        </section>
        <WhatYouGet />
        <ContentStrategySection />

        <CarouselComponent />
        <YourValues />
        <TurnYourStorySection />
      </div>
      <Footer />
    </>
  );
};
